import {
  AbstractControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import { FileService } from '../../../../core/services/file.service';
/**
 * Custom Validator Service
 */

export class CustomValidatorsService {
  /**
   * Invalid Url Validator
   */
  static url(abs: AbstractControl): ValidationErrors | null {
    if (
      abs.value &&
      !RegExp(/(http:\/\/)..*|(https:\/\/)..*/gi).test(abs.value)
    ) {
      return { url: true };
    }
    return null;
  }

  static password(abs: AbstractControl): ValidationErrors | null {
    if (
      abs.value &&
      !RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/).test(
        abs.value,
      )
    ) {
      return { password: true };
    }
    return null;

    // const value: string = abs.value || '';
    // if (!value) return {
    //   missingLower: true,
    //   missingUpper: true,
    //   missingNumber: true,
    //   missingSpecial: true,
    //   minLength: true,
    // };
    // // defining test regex
    // const errors: ValidationErrors = {};
    // const hasLowerCase = /[a-z]/.test(value);
    // const hasUpperCase = /[A-Z]/.test(value);
    // const hasNumeric = /\d/.test(value);
    // const hasSpecialChar = /[\W_]/.test(value);
    // const isMinLength = value.length >= 8;
    // // errors
    // if (!hasLowerCase) errors['missingLower'] = true
    // if (!hasUpperCase) errors['missingUpper'] = true
    // if (!hasNumeric) errors['missingNumber'] = true
    // if (!hasSpecialChar) errors['missingSpecial'] = true
    // if (!isMinLength) errors['minLength'] = true
    // // return
    // return Object.keys(errors).length > 0 ? errors : null;
  }

  static confirmPassword(form: FormGroup) {
    return (abs: AbstractControl): ValidationErrors | null => {
      const password = form.controls['password'];
      if (abs?.value && password?.value && abs?.value != password?.value) {
        return { confirmPassword: true };
      }
      return null;
    };
  }

  // static confirmPasswordValidator(abs: AbstractControl): ValidationErrors | null {
  //   return abs.value.password === abs.value.confirmPassword
  //   ? null
  //   : { confirmPassword: true };
  // }

  static passwordMatch(password: string, confirmPassword: string): ValidatorFn {
    return (formGroup: AbstractControl): { [key: string]: any } | null => {
      const passwordControl = formGroup.get(password);
      const confirmPasswordControl: any = formGroup.get(confirmPassword);

      if (!passwordControl || !confirmPasswordControl) {
        return null;
      }

      if (
        confirmPasswordControl.errors &&
        !confirmPasswordControl.errors.confirmPassword
      ) {
        return null;
      }

      if (passwordControl.value !== confirmPasswordControl.value) {
        confirmPasswordControl.setErrors({ confirmPassword: true });
        return { confirmPassword: true };
      } else {
        confirmPasswordControl.setErrors(null);
        return null;
      }
    };
  }

  static number(abs: AbstractControl): ValidationErrors | null {
    if (abs.value && !new RegExp(/[0-9]/).test(abs.value)) {
      return { number: true };
    }
    return null;
  }

  static email(abs: AbstractControl): ValidationErrors | null {
    if (
      abs.value &&
      !new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/).test(abs.value)
    ) {
      return { invalidEmail: true };
    }
    return null;
  }

  static richTextMinLength(requiredLength: number) {
    return (abs: AbstractControl): ValidationErrors | null => {
      if (
        abs.value &&
        (document?.querySelector('.ql-editor') as any)?.innerText?.length <
          requiredLength
      ) {
        return {
          minlength: {
            requiredLength,
          },
        };
      }
      return null;
    };
  }

  static richTextMaxLength(requiredLength: number) {
    return (abs: AbstractControl): ValidationErrors | null => {
      if (
        abs.value &&
        (document?.querySelector('.ql-editor') as any)?.innerText?.length >
          requiredLength
      ) {
        return {
          maxlength: {
            requiredLength,
          },
        };
      }
      return null;
    };
  }

  static richMaxImages(max: number) {
    return (abs: AbstractControl): ValidationErrors | null => {
      if (
        abs.value &&
        (document?.querySelector('.ql-editor') as any)?.querySelectorAll('img')
          ?.length > max
      ) {
        return {
          maxImages: {
            max,
          },
        };
      }
      return null;
    };
  }

  static richTextImageSize(abs: AbstractControl): ValidationErrors | null {
    if (!abs.value) return null;
    let images = (
      document?.querySelector('.ql-editor') as any
    )?.querySelectorAll('img') as HTMLImageElement[];
    if (!images) return null;
    let imageNumbers: any[] = [];
    let isError = false;
    for (let index = 0; index < images.length; index++) {
      if (!FileService.checkIfImageIsValid(images[index].src)) {
        imageNumbers.push(index + 1);
        isError = true;
      }
    }

    return isError ? { richTextImageSize: imageNumbers } : null;
  }
} // End Class
